export default "__VITE_ASSET__80ba073f__"